import api from './api';

export interface LocalTaskItem {
  id: string;
  title: string;
  notes?: string | null;
  status: 'needsAction' | 'completed';
  due?: string | null;
  completed?: string | null;
  updated?: string | null;
}

/** Jak `listMyTasks`, ale poprawne błędy HTTP (np. 403) lecą dalej — do Taskera. */
export async function listUserTasksForView(opts?: { showCompleted?: boolean; forUserId?: string }): Promise<LocalTaskItem[]> {
  const params: any = {};
  if (typeof opts?.showCompleted !== 'undefined') params.showCompleted = String(opts.showCompleted);
  if (opts?.forUserId) params.forUserId = opts.forUserId;
  const res = await api.get('/user-tasks/items', { params });
  return (res.data?.data || []) as LocalTaskItem[];
}

export async function listMyTasks(opts?: { showCompleted?: boolean; forUserId?: string }): Promise<LocalTaskItem[]> {
  const params: any = {};
  if (typeof opts?.showCompleted !== 'undefined') params.showCompleted = String(opts.showCompleted);
  if (opts?.forUserId) params.forUserId = opts.forUserId;
  try {
    const res = await api.get('/user-tasks/items', { params });
    return (res.data?.data || []) as LocalTaskItem[];
  } catch (e: any) {
    // Soft‑fail: jeśli backend nie ma jeszcze endpointu /user-tasks (404) albo brak autoryzacji (401),
    // nie wywalaj całej strony – zwróć pustą listę. Inne błędy również zwracają pustą listę.
    if (e?.response?.status === 404 || e?.response?.status === 401) {
      return [];
    }
    return [];
  }
}

export async function createMyTask(payload: {
  title: string;
  notes?: string;
  due?: string | null;
  /** Tylko rola `admin` — zadanie trafia do listy wskazanego użytkownika. */
  forUserId?: string;
}): Promise<LocalTaskItem> {
  const res = await api.post('/user-tasks/items', payload);
  return res.data?.data as LocalTaskItem;
}

export async function completeMyTask(taskId: string): Promise<void> {
  await api.post('/user-tasks/complete', { taskId });
}

export async function deleteMyTask(taskId: string): Promise<void> {
  await api.post('/user-tasks/delete', { taskId });
}

export async function updateMyTask(taskId: string, payload: { title?: string; due?: string | null; status?: 'needsAction' | 'completed' }): Promise<void> {
  await api.post('/user-tasks/update', { taskId, ...payload });
}



